// O ecrã inicial da app (IDEA-029).
//
// Era uma página de entrada com um texto de abertura; passa a ser o ecrã
// inicial de uma app. Fica o título — "Era uma vez… A Nossa História" — e
// começam logo os widgets.
//
// Os parágrafos de abertura não foram apagados do projecto: continuam em
// `landing.paragrafos` (@historia/shared/content), só deixaram de ser a
// primeira coisa que se vê todos os dias. O `<Hero />` também lá está, inteiro,
// para o dia em que quisermos uma página "sobre nós".

import { motion, useReducedMotion } from "framer-motion";
import { landing } from "@historia/shared/content";
import { useHome } from "@/api/queries";
import { Consulta } from "@/components/ui/EstadoConsulta";
import { useTitle } from "@/components/ui/useTitle";
import { Flourish } from "@/components/ui/Flourish";
import { Widgets } from "@/components/inicio/Widgets";

export function Inicio() {
  useTitle();
  const query = useHome();
  const reduzir = useReducedMotion();

  return (
    <main className="mx-auto max-w-3xl px-4 py-8 sm:px-6">
      <motion.header
        initial={reduzir ? { opacity: 0 } : { opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="mb-8 text-center"
      >
        <p className="font-display text-lg italic text-ouro-600 sm:text-xl">{landing.kicker}</p>
        <h1 className="mt-1 font-display text-4xl font-semibold leading-tight text-tinta sm:text-5xl">
          {landing.titulo}
        </h1>
        <div className="mt-5 flex justify-center">
          <Flourish />
        </div>
      </motion.header>

      <Consulta query={query} linhas={3}>
        {(dados) => <Widgets dados={dados} />}
      </Consulta>
    </main>
  );
}
